import { uiConstants } from '../constants'
import { timeHelper, securityHelper } from '../../helpers'

export function addNotification(message, error = false) {
  return (dispatch) => {
    const notification = {
      message,
      time: timeHelper.currentTime(),
      guid: securityHelper.guid(),
      error
    }
    dispatch(pushNotificationToQueue(notification))
    setTimeout(() => {
      dispatch(removeNotification(notification.guid))
    }, 5000)
  }
}

function pushNotificationToQueue(payload) {
  return {
    type: uiConstants.PUSH_NOTIFICATION,
    payload
  }
}

export function removeNotification(guid) {
  return {
    type: uiConstants.REMOVE_NOTIFICATION,
    payload: guid
  }
}
